export default "__VITE_ASSET__DVSmdT3Y__"